const initialState = {
  digitalData: {
    pageInfo: {
      page_name: 'ag:vm:home',
      page_title: 'courtney: orange valley mall',
      game_name: 'courtney',
      site_country: 'us',
      site_language: 'en',
    }
  }
}

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_PAGE_NAME":
      const newState = {...state};
      newState.digitalData.pageInfo.page_name = action.payload.page_name;
      return {
        ...state,
        digitalData: {
          ...state.digitalData,
          pageInfo: {
            ...state.digitalData.pageInfo,
            page_name: action.payload.page_name
          }
        }
      };
    default:
      return state;
  }
};

export default rootReducer;